module.exports = __webpack_public_path__ + "static/media/hackudc.dfcccc67.png";